<div class="bg-container">
  <div class="cros-icon" (click)="close()">&#x2715;</div>
<div class="view-dialog-container">

  <div class="body-container">
    <p class="body-pera">Welcome to the</p>
    <div class="head-text">
      CONSTRUCTION PATHWAYS <br />
      EXPERIENCE PORTAL
    </div>

    <p class="italic">Great to have you here!</p>

    <p class="inter">
      This portal helps you manage and track your participation in<br />
      construction-related experiences, including school incursions,<br />
      excursions and work experience.
    </p>
    <div class="sec-head">Here’s what you can do in the portal:</div>

    <li class="body-pera">
      See your upcoming construction pathways incursions and excursions.
    </li>
    <li class="body-pera">
      Log and keep track of your work experience and approved external
      activities.
    </li>
    <li class="body-pera">Track your participation and progress.</li>
    <li class="body-pera">
      Helps create a base CV to apply for future opportunities in construction.
    </li>

    <div class="sec-head">If you need help at any time, you can:</div>

    <li class="body-pera">
      Visit the <strong>FAQ</strong> section in the portal.
    </li>
    <li class="body-pera">Reach out to your teacher! Or,</li>
    <li class="body-pera">
      Contact us at <strong>constructionpathways&#64;csq.org.au</strong>
    </li>
    <div class="d-flex justify-content-between align-items-center mt-3">
      <p class="body-pera inter italic">
        You can close this message<br />
        and get started on your potential<br />
        future in construction. Let’s go!
      </p>

      <div class="d-grid gap-2">
        <button (click)="close()">GET STARTED</button>
        <div class="check-box-container">
          <div class="checkInput">
            <div *ngIf="dontShowAgain" class="checkInput-active">
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.6425 0H4.3575C1.6275 0 0 1.6275 0 4.3575V10.635C0 13.3725 1.6275 15 4.3575 15H10.635C13.365 15 14.9925 13.3725 14.9925 10.6425V4.3575C15 1.6275 13.3725 0 10.6425 0ZM11.085 5.775L6.8325 10.0275C6.7275 10.1325 6.585 10.1925 6.435 10.1925C6.285 10.1925 6.1425 10.1325 6.0375 10.0275L3.915 7.905C3.6975 7.6875 3.6975 7.3275 3.915 7.11C4.1325 6.8925 4.4925 6.8925 4.71 7.11L6.435 8.835L10.29 4.98C10.5075 4.7625 10.8675 4.7625 11.085 4.98C11.3025 5.1975 11.3025 5.55 11.085 5.775Z"
                  fill="#007BFF"
                />
              </svg>
            </div>
            <div *ngIf="!dontShowAgain" class="checkInput-inactive">
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.3125 16.125H5.8125C1.74 16.125 0 14.385 0 10.3125V5.8125C0 1.74 1.74 0 5.8125 0H10.3125C14.385 0 16.125 1.74 16.125 5.8125V10.3125C16.125 14.385 14.385 16.125 10.3125 16.125ZM5.8125 1.125C2.355 1.125 1.125 2.355 1.125 5.8125V10.3125C1.125 13.77 2.355 15 5.8125 15H10.3125C13.77 15 15 13.77 15 10.3125V5.8125C15 2.355 13.77 1.125 10.3125 1.125H5.8125Z"
                  fill="#8C8C8C"
                />
              </svg>
            </div>
            <input
              type="checkbox"
              id="dontShowAgain"
              [(ngModel)]="dontShowAgain"
              (ngModelChange)="onCheckboxChange($event)"
            />
          </div>
          <label for="dontShowAgain">Don’t show this again</label>
        </div>
      </div>
    </div>

    <!-- <div class="video-container">
        <div class="video-link">
          <div class="d-flex align-items-center">
            <button (click)="onPlayVideo()" class="watch-button">
              Watch video
            </button>
            <img src="assets/images/video-icon.svg" />
          </div>
        </div>

        <button (click)="close()">
          Get started
          <svg
            width="12"
            height="10"
            viewBox="0 0 12 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.6667 4.99232C11.6626 4.5539 11.486 4.13474 11.175 3.82566L7.6 0.242327C7.44386 0.0871182 7.23266 0 7.0125 0C6.79235 0 6.58114 0.0871182 6.425 0.242327C6.34689 0.319796 6.2849 0.411964 6.24259 0.513513C6.20028 0.615062 6.1785 0.723983 6.1785 0.833993C6.1785 0.944003 6.20028 1.05292 6.24259 1.15447C6.2849 1.25602 6.34689 1.34819 6.425 1.42566L9.16667 4.15899H0.833333C0.61232 4.15899 0.400358 4.24679 0.244078 4.40307C0.0877975 4.55935 0 4.77131 0 4.99232C0 5.21334 0.0877975 5.4253 0.244078 5.58158C0.400358 5.73786 0.61232 5.82565 0.833333 5.82565H9.16667L6.425 8.56732C6.26808 8.72313 6.17949 8.9349 6.1787 9.15604C6.17792 9.37717 6.26502 9.58956 6.42083 9.74648C6.57665 9.9034 6.78842 9.992 7.00955 9.99278C7.23069 9.99356 7.44308 9.90646 7.6 9.75065L11.175 6.16732C11.488 5.8562 11.6648 5.43364 11.6667 4.99232V4.99232Z"
              fill="white"
            />
          </svg>
        </button>
      </div> -->
  </div>
</div>
</div>
